const coconutPulpData = {
  hero_section: {
    title: "Premium Tender Coconut Pulp Collection",
    description: "100% Natural • No Preservatives • Tropical Essence",
    src: "videos/coconut-processing.webm",
  },
  description: {
    title: "Premium Tender Coconut Pulp Collection",
    main_description:
      "Discover our range of 100% natural tender coconut pulp, crafted from the finest coconuts to preserve the authentic tropical flavors and natural sweetness.",
    segment_description:
      "Perfect for beverages, desserts, and traditional culinary applications.",
    variety_description:
      "Available in various grades and pack sizes to suit every commercial need.",
  },
  main_product: {
    title: "Premium Tender Coconut Pulp",
    description: "Our tender coconut pulp delivers rich tropical flavor with natural sweetness. Perfect for beverages, desserts, and culinary applications that require authentic coconut taste and creamy texture.",
    image: "New-Images/Tender coconut.png",
    mainFeatures: [
      "Rich tropical coconut flavor",
      "Natural sweetness profile",
      "Creamy texture",
      "Perfect for beverages and desserts",
      "Traditional processing methods",
      "Consistent quality and freshness"
    ],
    nutrition: {
      servingSize: "50g",
      calories: "130",
      fat: "9g (Sat. fat: 6g)",
      carbs: "10g (Sugar: 10g, Added: 15g)",
      fiber: "3g",
      protein: "1g",
      sodium: "5mg",
      potassium: "100mg"
    }
  },
  products: [
    {
      id: "1",
      name: "Premium Tender Coconut Pulp",
      image: "New-Images/Tender coconut.png",
      features: [
        "Rich coconut flavor",
        "Natural sweetness",
        "Creamy texture",
        "Perfect for beverages"
      ],
      meta: {
        weight: "Customized pack sizes"
      }
    }
  ],

  text_section: {
    title: "Tender Coconut Pulp Excellence",
    description: "Our tender coconut pulp is processed from the finest handpicked coconuts using advanced processing techniques. We maintain strict quality control to ensure consistent flavor, texture, and nutritional value in every batch.",
  },
  
  feature_text_section: {
    title: "Perfect for Tropical Applications",
    subline: "From beverages to desserts – authentic coconut flavor in every application!",
    description:
      "Ideal for beverage manufacturers, dessert producers, traditional food makers, and culinary professionals who demand authentic tropical coconut taste.",
  },
  
  feature_cards_info_card: [
    {
      id: 1,
      image: "beverage-applications.webp",
      title: "Beverage Applications",
      description:
        "Perfect for coconut water, tropical smoothies, and refreshing drink mixes with authentic coconut flavor.",
    },
    {
      id: 2,
      image: "dessert-applications.webp",
      title: "Dessert Applications",
      description:
        "Ideal for ice creams, puddings, cakes, and traditional sweets requiring authentic coconut taste.",
    },
    {
      id: 3,
      image: "culinary-applications.webp",
      title: "Culinary Applications",
      description:
        "Excellent for traditional curries, modern cuisine, and specialty dishes requiring coconut base.",
    },
  ],
  
  overlay_card: [
    {
      id: 1,
      key: "Natural Processing",
      image: "natural-processing.webp",
      title: "Natural Processing",
      description:
        "No artificial preservatives, colors, or additives—just pure, natural coconut goodness",
    },
    {
      id: 2,
      key: "Quality Assurance",
      image: "quality-assurance.webp",
      title: "Quality Assurance",
      description:
        "Rigorous testing and quality control at every stage ensures premium standards",
    },
    {
      id: 3,
      key: "Consistent Supply",
      image: "consistent-supply.webp",
      title: "Consistent Supply",
      description:
        "Reliable production capacity and supply chain for your business needs",
    },
    {
      id: 4,
      key: "Tropical Excellence",
      image: "tropical-excellence.webp",
      title: "Tropical Excellence",
      description:
        "Specialized processing to preserve natural tropical flavors and characteristics",
    },
  ],
  
  why_choose_section: {
    title: "Why Choose Our Tender Coconut Pulp",
    description: "Discover the perfect blend of traditional authenticity and modern quality standards that make our tender coconut pulp the preferred choice for food manufacturers worldwide.",
  },
};

export default coconutPulpData;
